module.exports = __webpack_public_path__ + "media/site/images/ecommerce/ecommerce-solutions-for-any-device.en@1x-6697b3e69a7760ccc1fbbb227ec9ed2e.png";